import { z } from "zod";
import { EmploymentType, UserRole, UserStatus } from "@carry/shared";
import { PublicIdSchema } from "./common";

export const User = z.object({
  id: PublicIdSchema, // 外部公開は全て public_id
  role: UserRole,
  status: UserStatus,
  name: z.string(),
  email: z.email().nullable(),
  phone: z.string().nullable(),
  line_linked: z.boolean(),
  // 雇用形態 (ドライバー向け)。運転日報の休憩算出ルール分岐に使う。非ドライバーは null。
  employment_type: EmploymentType.nullable().optional(),
  // ドライバー固有属性は免許有効期限のみ。出発・帰着は車両保管場所 (vehicles) で管理する。
  license_expires_at: z.iso.date().nullable().optional(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }),
});

export const UpdateUserInput = z.object({
  name: z.string().min(1).max(100),
  role: UserRole,
  status: UserStatus,
  employment_type: EmploymentType.nullable().optional(),
  license_expires_at: z.iso.date().nullable().optional(),
});

/** self プロフィール更新用 (role/status を含めない = 権限昇格防止)。 */
export const UpdateProfileInput = z.object({
  name: z.string().min(1).max(100),
  phone: z.string().max(50).nullable().optional(),
});

export type UserDto = z.infer<typeof User>;
export type UpdateUserInputDto = z.infer<typeof UpdateUserInput>;
export type UpdateProfileInputDto = z.infer<typeof UpdateProfileInput>;
